export const undertakingModalStyles = {
  paper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  container: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pb: 2,
    pt: 2,
    px: 2,
    borderRadius: '16px 16px 0 0',
  },
  messageText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
    lineHeight: 1.5,
  },
  customerIdHighlight: {
    fontWeight: 700,
  },
  panHighlight: {
    fontWeight: 700,
  },
  firmsList: {
    margin: 0,
    paddingLeft: '20px',
    listStyleType: 'disc',
  },
  firmItem: {
    marginBottom: '4px',
    display: 'list-item',
  },
  firmText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: 1.5,
  },
  actionsRow: {
    display: 'flex',
    gap: 2,
    width: '100%',
  },
  declineButton: {
    flex: 1,
    borderRadius: '8px',
    px: 2.75,
    py: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid rgba(0, 124, 191, 0.5)',
    '&:hover': {
      bgcolor: 'rgba(0, 124, 191, 0.04)',
    },
  },
  declineText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: '#007cbf',
    letterSpacing: '0.46px',
    lineHeight: '26px',
  },
  acceptButton: {
    flex: 1,
    bgcolor: '#007cbf',
    borderRadius: '8px',
    px: 2.75,
    py: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      bgcolor: '#006aa8',
    },
  },
  acceptText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: 'white',
    letterSpacing: '0.46px',
    lineHeight: '26px',
  },
};